import { SuccessIcon, ErrorIcon } from "../components/Icons";
import type { ModalType } from "../types/form.types";

export const MODAL_TYPES: ModalType = {
  success: {
    title: "modal.success.title",
    icon: <SuccessIcon />,
    message: "modal.success.text",
  },
  failure: {
    title: "modal.failure.title",
    icon: <ErrorIcon />,
    message: "modal.failure.text",
  },
  invalid: {
    title: "modal.failure.title",
    icon: <ErrorIcon />,
    message: "modal.invalid.text",
  },
};
